import React from "react";
import { ChevronDown } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { FAQS } from "@/data/content";

const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="relative bg-slate-50 py-24 md:py-32">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <Reveal className="text-center mb-14">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand">08 — FAQ</p>
          <h2 className="font-heading font-extrabold text-[#0b2c4d] text-4xl md:text-5xl tracking-tight mt-3 leading-tight">
            Frequently asked questions
          </h2>
          <p className="mt-5 text-lg text-slate-500">
            Clear answers about endoscopic spine surgery, consultations and recovery.
          </p>
        </Reveal>

        <Reveal>
          <div className="space-y-3">
            {FAQS.map((f, i) => (
              <details
                key={f.q}
                name="home-faq"
                data-testid={`faq-item-${i}`}
                className="group glass-card rounded-2xl px-6 border-slate-200"
              >
                <summary className="flex items-center justify-between gap-4 cursor-pointer list-none [&::-webkit-details-marker]:hidden text-left text-[#0b2c4d] hover:text-brand py-5 font-heading font-bold text-base md:text-lg transition-colors">
                  {f.q}
                  <ChevronDown className="w-4 h-4 shrink-0 text-slate-400 transition-transform duration-200 group-open:rotate-180" />
                </summary>
                <div className="text-slate-500 leading-relaxed pb-5">{f.a}</div>
              </details>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FAQ;
